<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>模拟用户信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-button
          v-if="$hasPerm('tenant:simulation_user:show_create')"
          class="el-icon-plus"
          type="primary"
          size="mini"
          @click="showCreate"
          >添加模拟盘用户</el-button
        >
        <el-button
          v-if="$hasPerm('tenant:simulation_user:show_del')"
          type="primary"
          @click="showDel"
          class="del"
          size="mini"
          >删除模拟仓位</el-button
        >
        <el-select
          :value="queryType"
          @change="setQueryType"
          placeholder="请选择账户类型"
          size="mini"
        >
          <el-option
            v-for="item in queryTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          placeholder="请输入内容"
          clearable
          v-model="queryValue"
          size="mini"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input
          placeholder="请输入真实姓名"
          clearable
          v-model="realName"
          size="mini"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select
          v-model="userStatus"
          placeholder="请选择用户状态"
          size="mini"
        >
          <el-option>请选择</el-option>
          <el-option
            v-for="item in status"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <!-- <el-select v-model="userType" placeholder="请选择用户类型">
          <el-option>请选择</el-option>
          <el-option
            v-for="item in Shareholder"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <el-select v-model="mark" placeholder="请筛选异常账户" size="mini">
          <el-option>全部</el-option>
          <el-option
            v-for="item in ifMark"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button type="primary" @click="handleSearch" size="mini"
          >搜索</el-button
        >
      </div>
      <user-list @refresh="refreshList"></user-list>
      <Create @refresh="refreshList"></Create>
      <Del />
    </el-card>
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import Create from "./components/create";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import Del from "./components/del";

export default {
  name: "User",
  components: {
    UserList,
    Create,
    Del,
  },
  data() {
    return {
      isShow: false,
      seletData: {},
      queryValue: "",
      realName: "",
      userStatus: "",
      userType: 1,
      mark: null,
      status: [
        { value: 0, label: "激活" },
        { value: "-1", label: "冻结" },
      ],
      Shareholder: [
        { value: 1, label: "模拟盘用户" },
        { value: 2, label: "普通用户" },
      ],
      // Shareholder: [
      //   { value: '1', label: '无效用户' },
      //   { value: '2', label: '普通用户' },
      //   { value: '3', label: '初级股东' },
      //   { value: '4', label: '中级股东' },
      //   { value: '5', label: '高级股东' }
      // ],
      ifMark: [
        { value: true, label: "异常账户" },
        { value: false, label: "非异常账户" },
      ],
    };
  },
  computed: {
    ...mapState("userOldSimulation", [
      "queryType",
      "queryTypeList",
      "pagination",
    ]),
  },
  methods: {
    ...mapActions("userOldSimulation", ["list"]),
    ...mapMutations("userOldSimulation", [
      "setQueryType",
      "setCreateVisible",
      "setDelVisible",
    ]),
    refreshList(data = {}) {
      this.list({
        queryType: this.queryType,
        queryValue: this.queryValue,
        realName: this.realName,
        userStatus: this.userStatus,
        userType: this.userType,
        ...this.pagination,
        ...data,
      });
    },
    showCreate() {
      this.setCreateVisible(true);
    },
    showDel() {
      this.setDelVisible(true);
    },
    handleSearch() {
      this.seletData = {
        queryType: this.queryType,
        queryValue: this.queryValue,
        realName: this.realName,
        userType: this.userType,
        userStatus: this.userStatus,
        mark: this.mark,
        ...PAGINATION,
      };
      this.list({
        queryType: this.queryType,
        queryValue: this.queryValue,
        realName: this.realName,
        userType: this.userType,
        userStatus: this.userStatus,
        mark: this.mark,
        ...PAGINATION,
      });
    },
  },
  created() {
    this.list({
      queryType: QUERY_TYPE[0].value,
      queryValue: this.queryValue,
      realName: this.realName,
      userStatus: this.userStatus,
      userType: this.userType,
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" scoped>
.page-actions {
  margin-bottom: 10px;
}
</style>
